import { takeLatest, all } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../_config";

import {
  autoLoginWithToken,
  checkValidToken,
  createUpdateUserGame,
  forgotPassword,
  getRegistrationFieldsData,
  getUserProfile,
  loginUser,
  loginUserWithOtp,
  loginWithEmail,
  logoutUser,
  registration,
  resetPassword,
  saveNotification,
  updateDisplayName,
  updateDob,
  updateUserProfile,
} from "./userSaga";

import { getCities, getCountries, getStates, newsletterSignup } from "./commonSaga";

import {
  getEventList,
  getEventGameList,
  getEventGameDetails,
  getUpcomingEventList,
  pickRider,
  joinEventGame,
  viewLeaderBoard,
  tvImageDetails,
  saveVote,
  getGameDetails,
  getPrizeDetails,
  getRodeoEventGeoLocations,
  getLeaderboardLocationList,
  performanceList,
  winningTicketResults,
  mostPopularPicks,
  getMyTeam,
  getShareImageLink,
  yourPicks,
  getGameStatusText,
  getEventGroupList,
  viewGroupLeaderBoard,
} from "./eventSaga";

import { getCmsContent } from "./cmsSaga";
import {
  getLeagueLeaderboard,
  getPastEventList,
  getVsLeagueLeaderboard,
  groupTvImageDetails,
  saveLeagueCode,
  savePixelLog,
} from "./eventSagaNew";

export function* sagas() {
  yield all([
    // user saga
    takeLatest(SAGA_ACTIONS.USER.DETAILS, getUserProfile),
    takeLatest(SAGA_ACTIONS.USER.LOGIN, loginUser),
    takeLatest(SAGA_ACTIONS.USER.LOGIN_WITH_OTP, loginUserWithOtp),
    takeLatest(SAGA_ACTIONS.USER.LOGIN_WITH_EMAIL, loginWithEmail),
    takeLatest(SAGA_ACTIONS.USER.FORGOT_PASSWORD, forgotPassword),
    takeLatest(SAGA_ACTIONS.USER.RESET_PASSWORD, resetPassword),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION, registration),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_PROFILE, updateUserProfile),
    takeLatest(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, checkValidToken),

    takeLatest(SAGA_ACTIONS.USER.LOGOUT, logoutUser),
    takeLatest(SAGA_ACTIONS.USER.AUTO_LOGIN, autoLoginWithToken),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, updateDisplayName),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_DOB, updateDob),
    takeLatest(SAGA_ACTIONS.USER.SAVE_NOTIFICATION, saveNotification),
    takeLatest(SAGA_ACTIONS.USER.CREATE_UPDATE_USER_GAME, createUpdateUserGame),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, getRegistrationFieldsData),

    //Event Saga
    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_LIST, getEventList),
    takeLatest(SAGA_ACTIONS.EVENT.GET_PAST_EVENT_LIST, getPastEventList),
    takeLatest(SAGA_ACTIONS.EVENT.EVENT_GROUPS, getEventGroupList),
    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_GAME, getEventGameList),
    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_DETAILS, getEventGameDetails),
    takeLatest(SAGA_ACTIONS.EVENT.PICK_RIDER, pickRider),
    takeLatest(SAGA_ACTIONS.EVENT.LEADERBOARD, viewLeaderBoard),
    takeLatest(SAGA_ACTIONS.EVENT.GROUP_LEADERBOARD, viewGroupLeaderBoard),
    takeLatest(SAGA_ACTIONS.EVENT.GET_UPCOMING_EVENT, getUpcomingEventList),
    takeLatest(SAGA_ACTIONS.EVENT.JOIN_EVENT_GAME, joinEventGame),
    takeLatest(SAGA_ACTIONS.TV_IMAGE.DETAILS, tvImageDetails),
    takeLatest(SAGA_ACTIONS.TV_IMAGE.GROUP_TV_DETAILS, groupTvImageDetails),
    takeLatest(SAGA_ACTIONS.EVENT.SAVE_VOTE, saveVote),
    takeLatest(SAGA_ACTIONS.EVENT.GET_GAME_DETAILS, getGameDetails),
    takeLatest(SAGA_ACTIONS.EVENT.PRIZE_DETAILS, getPrizeDetails),
    takeLatest(SAGA_ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS, getRodeoEventGeoLocations),
    takeLatest(SAGA_ACTIONS.EVENT.LEADERBOARD_LOCATION_LIST, getLeaderboardLocationList),
    takeLatest(SAGA_ACTIONS.EVENT.PERFORMANCE_LIST, performanceList),
    takeLatest(SAGA_ACTIONS.EVENT.WINNING_TICKET_RESULTS, winningTicketResults),
    takeLatest(SAGA_ACTIONS.EVENT.GET_MY_TEAM, getMyTeam),
    takeLatest(SAGA_ACTIONS.EVENT.MOST_POPULAR_PICKS, mostPopularPicks),
    takeLatest(SAGA_ACTIONS.EVENT.GET_SHARE_IMAGE_LINK, getShareImageLink),
    takeLatest(SAGA_ACTIONS.EVENT.YOUR_PICKS, yourPicks),
    takeLatest(SAGA_ACTIONS.EVENT.GET_GAME_STATUS_TEXT, getGameStatusText),
    takeLatest(SAGA_ACTIONS.EVENT.SAVE_LEAGUE_CODE, saveLeagueCode),
    takeLatest(SAGA_ACTIONS.EVENT.LEAGUE_LEADERBOARD, getLeagueLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.VS_LEAGUE_LEADERBOARD, getVsLeagueLeaderboard),
    takeLatest(SAGA_ACTIONS.EVENT.SAVE_PIXEL_LOG, savePixelLog),

    //CMS Saga
    takeLatest(SAGA_ACTIONS.CMS.GET_CMS, getCmsContent),

    //Common Saga
    takeLatest(SAGA_ACTIONS.COMMON.COUNTRIES, getCountries),
    takeLatest(SAGA_ACTIONS.COMMON.STATES, getStates),
    takeLatest(SAGA_ACTIONS.COMMON.CITIES, getCities),
    takeLatest(SAGA_ACTIONS.COMMON.NEWSLETTER_SIGNUP, newsletterSignup),
  ]);
}
